import { useSuspenseQuery } from '@tanstack/react-query';

import type { PracticeAccessSource } from '@nesso/practice-contracts/practice-access-rule.access-sources';

import { practiceMemberOptions } from '../api/practice-member.queries';
import { getMissingAccessSources } from './get-missing-access-sources';

export function useHasAccessSources(requiredAccessSources: PracticeAccessSource[]): boolean {
    const { data } = useSuspenseQuery(practiceMemberOptions());

    return getMissingAccessSources(data.accessSources, requiredAccessSources).length === 0;
}
